import { render, staticRenderFns } from "./TopNotifications.vue?vue&type=template&id=efc13788&scoped=true"
import script from "./TopNotifications.vue?vue&type=script&lang=js"
export * from "./TopNotifications.vue?vue&type=script&lang=js"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TopNotifications.vue?vue&type=style&index=1&id=efc13788&prod&scoped=true&lang=css"
import style2 from "./TopNotifications.vue?vue&type=style&index=2&id=efc13788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc13788",
  null
  
)

export default component.exports